module.exports = __webpack_public_path__ + "static/partner-img2-ed93de22bcaf849f5fa2b125139f9f6d.png";